import { fetchData } from '../../helpers/base_data_fetcher';
import moveRecaptchaBadge from './adjust_badge';

let recaptchaInputAdded = false;

const runRecaptcha = (form, moveRecaptcha = false) => {
  const action = form.name;
  fetchData('site').then((siteData) => {
    if (
      typeof grecaptcha.ready == 'function' &&
      form &&
      siteData.recaptcha_v3_site_key
    ) {
      grecaptcha.ready(() => {
        form.addEventListener('submit', (event) => {
          if (!recaptchaInputAdded && event.submitter.name != 'prev_step') {
            event.preventDefault();
            grecaptcha
              .execute(siteData.recaptcha_v3_site_key, {
                action: action,
              })
              .then((token) => {
                const recaptchaInput = document.createElement('input');
                recaptchaInput.name = 'recaptcha_token';
                recaptchaInput.type = 'hidden';
                recaptchaInput.value = token;
                form.appendChild(recaptchaInput);
                recaptchaInputAdded = true;
                form.querySelector('button[type="submit"]').click();
              });
          }
        });
        if (moveRecaptcha) {
          moveRecaptchaBadge();
        }
      });
    }
  });
};

export default runRecaptcha;
